import { ColDef } from 'ag-grid-community';
import { formatPhoneNumber, dateFormatter } from 'src/app/shared/functions';

export const AlertColumnDef: ColDef[] = [
  {
    // Company ID
    headerName: 'Company ID',
    field: 'company_id',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    // Selected Vendors
    headerName: 'Selected Vendors',
    field: 'alert_selected_vendors',
    resizable: true,
    flex: 1,
    width: 300,
    filter: 'agTextColumnFilter',
    pinned: 'left',
    valueFormatter: (params) => {
      return params.value && Array.isArray(params.value)
        ? params.value.join(', ')
        : params.value;
    },
  },
  {
    // Desired Qty
    headerName: 'Desired Qty',
    field: 'alert_desired_qty',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
  },
  {
    // Item UPC
    headerName: 'Item UPC',
    field: 'alert_item_upc',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  {
    // Item Name
    headerName: 'Model Number',
    field: 'alert_item_name',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  {
    // Item Description
    headerName: 'Item Description',
    field: 'alert_item_description',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {
    // Requestor
    headerName: 'Requestor',
    field: 'requestor',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
  },
  {
    // Created Date Time
    headerName: 'Created Date Time',
    field: 'created_date',
    resizable: true,
    width: 120,
    filter: 'agTextColumnFilter',
    valueFormatter: dateFormatter,
  },
  {
    // Alert Text Number
    headerName: 'Alert Text Number',
    field: 'alert_text_number',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
    valueFormatter: (params) => formatPhoneNumber(params.value),
  },
  {
    // Alert Email
    headerName: 'Alert Email',
    field: 'alert_email',
    resizable: true,
    width: 225,
    filter: 'agTextColumnFilter',
  },
];
export const AutoPurchaseColumnDef: ColDef[] = [
  {
    // Selected Vendors
    headerName: 'Selected Vendors',
    field: 'auto_purchase_selected_vendors',
    resizable: true,
    flex: 1,
    width: 300,
    filter: 'agTextColumnFilter',
    pinned: 'left',
    valueFormatter: (params) => {
      return params.value && Array.isArray(params.value)
        ? params.value.join(', ')
        : params.value;
    },
  },
  {
    // Desired Qty
    headerName: 'Desired Qty',
    field: 'auto_purchase_desired_qty',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
  },
  {
    // Item UPC
    headerName: 'Item UPC',
    field: 'auto_purchase_item_upc',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  {
    // Item Name
    headerName: 'Item Name',
    field: 'auto_purchase_item_name',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  {
    // Item Description
    headerName: 'Item Description',
    field: 'auto_purchase_item_description',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {
    // Starting Purchase Date
    headerName: 'Starting Purchase Date',
    field: 'auto_purchase_starting_date',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
  {
    // Ending Purchase Date
    headerName: 'Ending Purchase Date',
    field: 'auto_purchase_ending_date',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
  {
    // Partial Orders Allowed
    headerName: 'Partial Orders Allowed',
    field: 'auto_purchase_partial_orders_allowed',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
  {
    // Created Date Time
    headerName: 'Created Date Time',
    field: 'created_date',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
  {
    // Requestor
    headerName: 'Requestor',
    field: 'requestor',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
  },
];
